import { createContext, useContext, useEffect, useMemo, useSyncExternalStore } from 'react';
import {
  applyDocumentLocale,
  getDirection,
  getLocale,
  setLocale as persistLocale,
  subscribeLocale,
} from 'core/i18n/localeStore';
import { translate } from 'core/i18n/messages';

const I18nContext = createContext(null);

function subscribe(callback) {
  return subscribeLocale(callback);
}

export function I18nProvider({ children }) {
  const locale = useSyncExternalStore(subscribe, getLocale, getLocale);

  useEffect(() => {
    applyDocumentLocale(locale);
  }, [locale]);

  const value = useMemo(() => ({
    locale,
    dir: getDirection(locale),
    t: (key, vars) => translate(locale, key, vars),
    setLocale: persistLocale,
  }), [locale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within I18nProvider');
  }
  return context;
}
